import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {type CheckinPincodes} from './checkin-pincodes';
import {type CheckinPincodesResponse} from './checkin-pincodes-data';

export function checkinPincodesTypePatcher(data: CheckinPincodesResponse): RestTypeWithTypename<CheckinPincodes> {
    return {
        __typename: 'CheckinPincodesData',
        checkinPincodes: data.map(c => ({__typename: 'CheckinPincode', ...c})),
    };
}
